module.exports = __webpack_public_path__ + "d0416826ca8b1c571fc46fc798262715.svg";